
<div class="container">
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col col-md-4 mt-2 mb-2" *ngFor="let cronJob of cronJobs">
            <button class="btn btn-block btn-primary" type="button" (click)="triggerCronJob(cronJob)">{{ cronJob.description }}</button>
          </div>
          <div class="col col-md-4 mt-2 mb-2">
            <button class="btn btn-block btn-primary" type="button" [uploadFileTo]="'/api/cron-admin/import-itsm-product-type'" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Upload Product Type Information'">Import ITSM Product Types</button>
          </div>
          <div class="col col-md-4 mt-2 mb-2">
            <button class="btn btn-block btn-primary" type="button" (click)="clear()">Clear</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="log-output">
        <p *ngFor="let log of logData" [ngClass]="log.type">
          <ng-container [ngSwitch]="log.type">
            <ng-template ngSwitchCase="info"><b>[INFO]</b> [{{ log.name }}] {{ log.message }} [{{ log.step }} / {{ log.totalSteps }}]</ng-template>
            <ng-template ngSwitchCase="warn"><b>[WARN]</b> [{{ log.name }}] {{ log.message }} [{{ log.step }} / {{ log.totalSteps }}]</ng-template>
            <ng-template ngSwitchCase="success"><b>[PASS]</b> [{{ log.name }}] {{ log.message }}</ng-template>
            <ng-template ngSwitchCase="failure"><b>[FAIL]</b> [{{ log.name }}] {{ log.message }}</ng-template>
            <ng-template ngSwitchDefault>       <b>[????]</b> {{ log | json }}</ng-template>
          </ng-container>
        </p>
      </div>
    </div>
  </div>
</div>